import LeadFormModal from '@v4/single-guide/components/organisms/LeadFormModal/LeadFormModal';

export default LeadFormModal;
